import { render, staticRenderFns } from "./PagseguroSettings.vue?vue&type=template&id=a026e42c"
import script from "./PagseguroSettings.vue?vue&type=script&lang=js"
export * from "./PagseguroSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports